// extracted by mini-css-extract-plugin
export default {"board_item":"board-item-box_board_item__jJCmt","green_item":"board-item-box_green_item__xCCZ0","red_item":"board-item-box_red_item__GaLxV"};